import * as React from "react";
import { Accordion } from "react-accessible-accordion";
import { Alert, ButtonGroup } from "react-bootstrap";
import { connect } from "react-redux";
import "react-table/react-table.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Action, Dispatch } from "redux";
import "../../../Common/css/fancy-example.css";
import { RootState } from "../../../Shared/React/store/rootReducer";
import { InvoiceTableProperties } from "../../../Shared/React/typings/api-models/invoice/InvoiceTable";
import { getTableSetup, InvoiceGroup, InvoiceType } from "../service/tableSetup";
import { actions } from "../store/invoices";
import { IInvoicePageState } from "../store/invoices/reducer";
import { AlertModal, Button } from "./_atoms/Index";
import { FileInput } from "./_atoms/FileInput";
import InvoiceTable from "./InvoiceTable";

class InvoicePage extends React.Component<InvoicePageProps, IInvoicePageState> {
  constructor(props: InvoicePageProps) {
    super(props);
    this.approveSelected = this.approveSelected.bind(this);
    this.approveSelectedWrapper = this.approveSelectedWrapper.bind(this);
    this.ignoreSelected = this.ignoreSelected.bind(this);
    this.holdSelected = this.holdSelected.bind(this);
    this.approveStandardInvoices = this.approveStandardInvoices.bind(this);
    this.previewInvoice = this.previewInvoice.bind(this);
    this.previewPdfInvoice = this.previewPdfInvoice.bind(this);
    this.openInvoiceTab = this.openInvoiceTab.bind(this);
    this.closePdfInvoice = this.closePdfInvoice.bind(this);
    this.approveInvoiceWithUpload = this.approveInvoiceWithUpload.bind(this);
    this.fetchingNewData = this.fetchingNewData.bind(this);
    this.completedFetchingNewData = this.completedFetchingNewData.bind(this);
    this.approveBatch = this.approveBatch.bind(this);
    this.state = {
      currentTable: null,
      fetchNewData: false,
      loading: false,
      previewResponse: null,
      showPreview: false,
      showApproveUpload: false,
      approveModalInvoiceGroupingId: null,
      showPreviewDisabledModal: false,
      loaded: false,
      downloadingInvoice: false,
      residentialStandardInvoices: getTableSetup(
        "residentialStandardInvoices",
        InvoiceType.Standard,
        InvoiceGroup.Residential,
        null,
        this.previewPdfInvoice,
        null,
        null,
        this.openInvoiceTab,
      ),
      residentialDuplicateInvoices: getTableSetup(
        "residentialDuplicateInvoices",
        InvoiceType.Duplicate,
        InvoiceGroup.Residential,
        "excelergyLdcAccountNumber",
        this.previewPdfInvoice,
        null,
        null,
        this.openInvoiceTab,
      ),
      residentialMismatchInvoices: getTableSetup(
        "residentialMismatchInvoices",
        InvoiceType.Mismatch,
        InvoiceGroup.Residential,
        null,
        this.previewPdfInvoice,
        null,
        null,
        this.openInvoiceTab,
      ),

      communityStandardInvoices: getTableSetup(
        "communityStandardInvoices",
        InvoiceType.Standard,
        InvoiceGroup.Community,
        null,
        this.previewInvoice,
      ),
      communityDuplicateInvoices: getTableSetup(
        "communityDuplicateInvoices",
        InvoiceType.Duplicate,
        InvoiceGroup.Community,
        "excelergyLdcAccountNumber",
        this.previewInvoice,
      ),
      communityMismatchInvoices: getTableSetup(
        "communityMismatchInvoices",
        InvoiceType.Mismatch,
        InvoiceGroup.Community,
        null,
        this.previewInvoice,
      ),

      pendingStandardCharges: getTableSetup("pendingStandardCharges", InvoiceType.Standard, InvoiceGroup.Pending),
      pendingDuplicateCharges: getTableSetup(
        "pendingDuplicateCharges",
        InvoiceType.Duplicate,
        InvoiceGroup.Pending,
        "ldcAccountNumber",
      ),
      pendingMismatchCharges: getTableSetup("pendingMismatchCharges", InvoiceType.Mismatch, InvoiceGroup.Pending),

      commercialSingleInvoices: getTableSetup(
        "commercialSingleInvoices",
        InvoiceType.Standard,
        InvoiceGroup.Commercial,
        null,
        this.previewPdfInvoice,
        this.showUploadModal,
        this.approveSelectedWrapper,
        this.openInvoiceTab,
      ),
      commercialMultipleInvoices: getTableSetup(
        "commercialMultipleInvoices",
        InvoiceType.Multiple,
        InvoiceGroup.Commercial,
        null,
        this.previewPdfInvoice,
        this.showUploadModal,
        this.approveSelectedWrapper,
        this.openInvoiceTab,
      ),
      commercialSingleSelectInvoices: getTableSetup(
        "commercialSingleSelectInvoices",
        InvoiceType.SingleSelect,
        InvoiceGroup.Commercial,
        null,
        this.previewPdfInvoice,
        this.showUploadModal,
        this.approveSelectedWrapper,
        this.openInvoiceTab,
      ),
      commercialSentSingleInvoices: getTableSetup(
        "commercialSentSingleInvoices",
        InvoiceType.StandardSent,
        InvoiceGroup.Commercial,
        null,
        this.previewPdfInvoice,
        this.showUploadModal,
        this.approveSelectedWrapper,
        this.openInvoiceTab,
      ),
    };
  }

  public fetchingNewData = () => {
    this.props.fetchingNewData();
    this.setState({
      loading: true,
    });
  };

  public completedFetchingNewData = () => {
    this.props.completedFetchingNewData();
    this.setState({
      loading: false,
      currentTable: null,
    });
  };

  public approveSelected = (currentlySelected: string[], currentTable: InvoiceTableProperties) => {
    this.props.approveSelected(currentTable.invoiceGroup, currentlySelected);
    this.setState({
      loading: true,
      currentTable,
    });
  };

  public approveBatch = (batchSize: number, currentTable: InvoiceTableProperties) => {
    this.props.approveBatch(currentTable.invoiceGroup, InvoiceType.Standard, batchSize);
    this.setState({
      loading: true,
      currentTable,
    });
  };
  public clearPreview = () => {
    this.props.clearPreview();
  };

  public clearApproveUpload = () => {
    this.setState({
      showApproveUpload: false,
      approveModalInvoiceGroupingId: null,
    });
  };

  public approveSelectedWrapper = (invoiceGroupingId: number, tableName: string) => {
    this.props.approveSelected(this.state[tableName].invoiceGroup, [invoiceGroupingId.toString()]);
    this.setState({
      loading: true,
      currentTable: this.state[tableName],
    });
  };

  public showUploadModal = (invoiceGroupingId: number, tableName: string) => {
    this.setState({
      showApproveUpload: true,
      currentTable: this.state[tableName],
      approveModalInvoiceGroupingId: invoiceGroupingId,
    });
  };

  public ignoreSelected = (currentlySelected: string[], currentTable: InvoiceTableProperties) => {
    this.props.ignoreSelected(currentTable.invoiceGroup, currentlySelected);
    this.setState({
      loading: true,
      currentTable,
    });
  };

  public holdSelected = (currentlySelected: string[], currentTable: InvoiceTableProperties) => {
    this.props.holdSelected(currentTable.invoiceGroup, currentlySelected);
    this.setState({
      loading: true,
      currentTable,
    });
  };

  public approveStandardInvoices = (invoiceGroup: string, currentTable: InvoiceTableProperties) => {
    this.props.approveStandardInvoices(invoiceGroup);
    this.setState({
      loading: true,
      currentTable,
    });
  };

  public previewInvoice(invoiceNumber: string): any {
    this.props.previewInvoice(invoiceNumber);
  }

  public approveInvoiceWithUpload(fileData: any): any {
    this.props.approveInvoiceWithUpload(this.state.approveModalInvoiceGroupingId, fileData);
    this.setState({
      showApproveUpload: false,
      approveModalInvoiceGroupingId: null,
      loading: true,
    });
  }

  public previewPdfInvoice(documentKey: string): any {
    this.props.getInvoicePdfData(documentKey, "false");
  }

  public openInvoiceTab(documentKey: string): any {
    this.props.openInvoiceTab(documentKey);
  }

  public closePdfInvoice(): any {
    this.props.clearPreview();
    this.setState({
      previewResponse: null,
    });
  }

  public togglePreviewDisabledModal = () => {
    this.setState({ ...this.state, showPreviewDisabledModal: !this.state.showPreviewDisabledModal });
  };

  public togglePreviewDisabledModal2 = () => {
    this.props.closePreviewDisabledModal();
  };

  public shouldRefreshTable(table: InvoiceTableProperties): boolean {
    if (this.state.currentTable.tableId === table.tableId) {
      return true;
    } else if (
      this.state.currentTable.invoiceGroup === table.invoiceGroup &&
      this.state.currentTable.title === "Duplicates"
    ) {
      return true;
    }
    return false;
  }

  public render(): JSX.Element {
    return (
      <div>
        <div style={{ display: this.props.invoices.previewResponse ? "block" : "none" }}>
          <Button
            onClick={(): void => {
              this.closePdfInvoice();
            }}
            text="Close Preview"
            className="cyan-btn btn-lg"
            show={true}
            style={{ marginBottom: "5px" }}
          />
          <iframe src={this.props.invoices.previewResponse} style={{ height: "1000px", width: "100%" }} />
          <Button
            onClick={(): void => {
              this.closePdfInvoice();
            }}
            text="Close Preview"
            className="cyan-btn btn-lg pull-right"
            show={true}
          />
        </div>
        <div style={{ display: this.props.invoices.previewResponse ? "none" : "block" }}>
          <AlertModal
            show={this.props.invoices.showPreview}
            onHide={this.clearPreview}
            bodyText={this.props.invoices.previewResponse}
            isHtml={true}
            showCancel={false}
          />
          <AlertModal
            show={this.state.showApproveUpload}
            onHide={this.clearApproveUpload}
            bodyText={<FileInput uploadMethod={this.approveInvoiceWithUpload} cancelMethod={this.clearApproveUpload} />}
            isHtml={false}
            showCancel={false}
          />
          <AlertModal
            show={this.state.showPreviewDisabledModal}
            onHide={null}
            headerText="Invoice Preview Disabled"
            bodyText="Due to the large file size, preview for this invoice has been disabled.  Please download this invoice to review."
            confirmButtonAction={this.togglePreviewDisabledModal}
            confirmButtonText="Confirm"
            showCancel={false}
          />
          <AlertModal
            show={this.props.invoices.showPreviewDisabledModal}
            onHide={null}
            headerText="Invoice Preview Disabled"
            bodyText="Due to the large file size, preview for this invoice has been disabled.  Please download this invoice to review."
            confirmButtonAction={this.togglePreviewDisabledModal2}
            confirmButtonText="Confirm"
            showCancel={false}
          />
          <h2 className="blue-text">Invoices</h2>
          <Alert>
            Note: Any invoices displayed in a <span style={{ color: "#ff4c4c" }}>red</span> font have a due date in the
            past.
          </Alert>
          <Tabs>
            <TabList>
              {this.props.canViewResidential && (
                <Tab>
                  <h4>Residential</h4>
                </Tab>
              )}
              {this.props.canViewResidential && (
                <Tab>
                  <h4>Community</h4>
                </Tab>
              )}
              {this.props.canViewResidential && (
                <Tab>
                  <h4>Pending Charges</h4>
                </Tab>
              )}
              {this.props.canViewCommercial && (
                <Tab>
                  <h4>Commercial</h4>
                </Tab>
              )}
              {this.props.canViewCommercial && (
                <Tab>
                  <h4>Commercial Sent Invoices</h4>
                </Tab>
              )}
            </TabList>
            {this.props.canViewResidential && (
              <TabPanel>
                <Accordion accordion={false}>
                  <InvoiceTable
                    invoiceTable={this.state.residentialMismatchInvoices}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    isTreeTable={false}
                    fetchNewData={
                      this.props.invoices.fetchNewData &&
                      this.shouldRefreshTable(this.state.residentialMismatchInvoices)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />

                  <InvoiceTable
                    invoiceTable={this.state.residentialDuplicateInvoices}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    isTreeTable={true}
                    fetchNewData={
                      this.props.invoices.fetchNewData &&
                      this.shouldRefreshTable(this.state.residentialDuplicateInvoices)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />

                  <InvoiceTable
                    invoiceTable={this.state.residentialStandardInvoices}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    holdSelected={this.holdSelected}
                    approveAllStandard={this.approveStandardInvoices}
                    approveBatch={this.approveBatch}
                    isTreeTable={false}
                    fetchNewData={
                      this.props.invoices.fetchNewData &&
                      this.shouldRefreshTable(this.state.residentialStandardInvoices)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />
                </Accordion>
              </TabPanel>
            )}
            {this.props.canViewResidential && (
              <TabPanel>
                <Accordion accordion={false}>
                  <InvoiceTable
                    invoiceTable={this.state.communityMismatchInvoices}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    approveAllStandard={this.approveStandardInvoices}
                    isTreeTable={false}
                    fetchNewData={
                      this.props.invoices.fetchNewData && this.shouldRefreshTable(this.state.communityMismatchInvoices)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />

                  <InvoiceTable
                    invoiceTable={this.state.communityDuplicateInvoices}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    approveAllStandard={this.approveStandardInvoices}
                    isTreeTable={true}
                    fetchNewData={
                      this.props.invoices.fetchNewData && this.shouldRefreshTable(this.state.communityDuplicateInvoices)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />

                  <InvoiceTable
                    invoiceTable={this.state.communityStandardInvoices}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    approveAllStandard={this.approveStandardInvoices}
                    isTreeTable={false}
                    fetchNewData={
                      this.props.invoices.fetchNewData && this.shouldRefreshTable(this.state.communityStandardInvoices)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />
                </Accordion>
              </TabPanel>
            )}
            {this.props.canViewResidential && (
              <TabPanel>
                <Accordion accordion={false}>
                  <InvoiceTable
                    invoiceTable={this.state.pendingMismatchCharges}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    approveAllStandard={this.approveStandardInvoices}
                    isTreeTable={false}
                    fetchNewData={
                      this.props.invoices.fetchNewData && this.shouldRefreshTable(this.state.pendingMismatchCharges)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />

                  <InvoiceTable
                    invoiceTable={this.state.pendingDuplicateCharges}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    approveAllStandard={this.approveStandardInvoices}
                    isTreeTable={true}
                    fetchNewData={
                      this.props.invoices.fetchNewData && this.shouldRefreshTable(this.state.pendingDuplicateCharges)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />

                  <InvoiceTable
                    invoiceTable={this.state.pendingStandardCharges}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    approveAllStandard={this.approveStandardInvoices}
                    isTreeTable={false}
                    fetchNewData={
                      this.props.invoices.fetchNewData && this.shouldRefreshTable(this.state.pendingStandardCharges)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />
                </Accordion>
              </TabPanel>
            )}
            {this.props.canViewCommercial && (
              <TabPanel>
                <Accordion accordion={false}>
                  <InvoiceTable
                    invoiceTable={this.state.commercialSingleInvoices}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    isTreeTable={true}
                    fetchNewData={
                      this.props.invoices.fetchNewData && this.shouldRefreshTable(this.state.commercialSingleInvoices)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />

                  <InvoiceTable
                    invoiceTable={this.state.commercialMultipleInvoices}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    isTreeTable={true}
                    fetchNewData={
                      this.props.invoices.fetchNewData && this.shouldRefreshTable(this.state.commercialMultipleInvoices)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />

                  <InvoiceTable
                    invoiceTable={this.state.commercialSingleSelectInvoices}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    isTreeTable={false}
                    fetchNewData={
                      this.props.invoices.fetchNewData && this.shouldRefreshTable(this.state.commercialSingleInvoices)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />
                </Accordion>
              </TabPanel>
            )}
            {this.props.canViewCommercial && (
              <TabPanel>
                <Accordion accordion={false}>
                  <InvoiceTable
                    invoiceTable={this.state.commercialSentSingleInvoices}
                    approveSelected={this.approveSelected}
                    ignoreSelected={this.ignoreSelected}
                    isTreeTable={false}
                    isNormalTable={true}
                    hideIgnoreButton={true}
                    fetchNewData={
                      this.props.invoices.fetchNewData &&
                      this.shouldRefreshTable(this.state.commercialSentSingleInvoices)
                    }
                    fetchingNewData={this.fetchingNewData}
                    completedFetchingNewData={this.completedFetchingNewData}
                  />
                </Accordion>
              </TabPanel>
            )}
          </Tabs>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): InvoiceProps => {
  return {
    invoices: state.invoices,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return {
    removeInvoice: (invoiceNumber: string): Action => dispatch(actions.removeInvoice.request(invoiceNumber)),
    previewInvoice: (invoiceNumber: string): Action => dispatch(actions.previewInvoice.request(invoiceNumber)),
    ignoreSelected: (invoiceGroup: string, invoiceNumbers: string[]): Action =>
      dispatch(actions.ignoreSelected.request({ invoiceGroup, invoiceNumbers })),
    holdSelected: (invoiceGroup: string, invoiceNumbers: string[]): Action =>
      dispatch(actions.holdSelected.request({ invoiceGroup, invoiceNumbers })),
    approveSelected: (invoiceGroup: string, invoiceNumbers: string[]): Action =>
      dispatch(actions.approveSelected.request({ invoiceGroup, invoiceNumbers })),
    approveStandardInvoices: (invoiceGroup: string): Action =>
      dispatch(actions.approveStandardInvoices.request(invoiceGroup)),
    clearPreview: (): Action => dispatch(actions.clearPreview()),
    closePreviewDisabledModal: (): Action => dispatch(actions.closePreviewDisabledModal()),
    fetchingNewData: (): Action => dispatch(actions.fetchingNewData()),
    completedFetchingNewData: (): Action => dispatch(actions.completedFetchingNewData()),
    approveInvoiceWithUpload: (invoiceNumber: number, fileData: any): Action =>
      dispatch(actions.approveInvoiceWithUpload.request({ invoiceNumber, fileData })),
    getInvoicePdfData: (documentKey: string, download: string): Action =>
      dispatch(actions.getInvoicePdfData.request({ documentKey, download })),
    openInvoiceTab: (documentKey: string): Action => dispatch(actions.openInvoiceTab.request({ documentKey })),
    approveBatch: (invoiceGroup: string, invoiceType: string, batchSize: number) =>
      dispatch(actions.approveBatch.request({ invoiceGroup, invoiceType, batchSize })),
  };
};

interface DispatchProps {
  removeInvoice: (invoiceNumber: string) => Action;
  previewInvoice: (invoiceNumber: string) => Action;
  ignoreSelected: (invoiceGroup: string, invoiceNumbers: string[]) => Action;
  holdSelected: (invoiceGroup: string, invoiceNumbers: string[]) => Action;
  approveSelected: (invoiceGroup: string, invoiceNumbers: string[]) => Action;
  approveStandardInvoices: (invoiceGroup: string) => Action;
  approveBatch: (invoiceGroup: string, invoiceType: string, batchSize: number) => Action;
  clearPreview: () => Action;
  closePreviewDisabledModal: () => Action;
  fetchingNewData: () => Action;
  completedFetchingNewData: () => Action;
  approveInvoiceWithUpload: (invoiceNumber: number, fileData: any) => Action;
  getInvoicePdfData: (documentKey: string, download: string) => Action;
  openInvoiceTab: (documentKey: string) => Action;
}

export interface InvoiceProps {
  invoices: IInvoicePageState;
}

export interface InvoicePageProps extends DispatchProps, InvoiceProps {
  canViewCommercial: boolean;
  canViewResidential: boolean;
}

export default connect<InvoiceProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(InvoicePage);
